/**
 * Who may see what a drug costs us.
 *
 * Mirrors backend/src/utils/drugPricing.js, which does the actual withholding —
 * the API strips the fields, so this is only about not rendering a column of
 * "N/A" where the numbers used to be. drugPricing.test.js fails if the two
 * lists drift apart.
 *
 * An allowlist, matching the backend: an unrecognised role sees no prices
 * rather than inheriting them.
 */

export const PRICE_VISIBLE_ROLES = ['super_admin', 'pharmacy_manager', 'program_manager']

export function canSeeDrugPrices(user) {
  return PRICE_VISIBLE_ROLES.includes(user?.role)
}
